import { defineComponent as _defineComponent } from 'vue'
import {
  formatExperiencePeriod,
  previewHighLightClass
} from '@/utils/format-edit/englishResumePreview'


export default /*#__PURE__*/_defineComponent({
  __name: 'EnglishResumePreviewDocPage2',
  props: {
    jobsPage2: null,
    fullName: null,
    highlightMessage: null,
    currentCardId: { default: '' },
    idPrefix: { default: '' },
    isSample: { type: Boolean, default: false },
    cardChanged: { type: Boolean, default: false }
  },
  emits: ["go-card-to"],
  setup(__props: any, { emit }: { emit: ({ (e: 'go-card-to', id: string): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { jobsPage2: any[], fullName: string, highlightMessage: string, currentCardId: string | string[], idPrefix: string, isSample: boolean, cardChanged: boolean };





function goCardTo(id: string) {
  emit('go-card-to', id)
}

function highLightClass(cardId: string | string[]) {
  return previewHighLightClass(
    cardId,
    props.currentCardId,
    !!props.cardChanged,
    !!props.isSample
  )
}

return { __sfc: true,props, emit, goCardTo, highLightClass, formatExperiencePeriod }
}

})